import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import FormikInterested from "../modals/interestedModal";
import FormikReject from "../modals/RejectModal";
import FormikUpdate from "../modals/UpdateDetailsModal";
import { connect } from "react-redux";

const OrderDetailsHeader = (props) => {

    useEffect(() => {
    }, [props?.orderDetail]);

    const [captchaReload, setCaptchaReload] = useState(false)
    let reloadCaptcha = ()=>{
        setCaptchaReload(true)
    }

    return (
        <React.Fragment>
            <div id="dispatch_bar">
                <div className="container-fluid dip_bar">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="d-flex justify-content-between">
                                <label className="mt-2 font-weight-normal">{props.title}</label>
                                <div className="form-inline">
                                    {props.broadcastTimeLeft ?
                                        <h6 style={{ marginRight: "450px" }} className="mt-1 p-bold-600">{props.broadcastTimeLeft}</h6>
                                        : null}

                                    {props.hideInterest != true && (props.vendor_interest_status != "INTRST" && props.vendor_interest_status != "REJECT") ?
                                        <FormikInterested uom={props.uom} vendor_id={props.auth.vendorId} bid={props.bidding} bid_amount={props.offered_rate} orderDetail={props.orderDetail} captchaReload={captchaReload} reloadCaptcha={reloadCaptcha} />
                                        : null}
                                    {props.hideUpdateDetails != true ?
                                        <FormikUpdate deliveryDetails={props.deliveryDetails} vendor_order_id={props.vendor_order_id} userKey={props.auth.vendorSpeedKey} vehicle_id={props.vehicleId} disableUpdateDetails={props.disableUpdateDetails} />
                                        : null}
                                    {props.hideReject != true && props.vendor_interest_status != "REJECT" ?
                                        <>
                                            {localStorage.getItem('customerNumber') == 1166 ?
                                                null :
                                                <FormikReject OrderStatus={props.order_status} />
                                            }
                                        </>
                                        : null}
                                    <Link to={props.LinkName}><i className="fas ml-3 mr-2 fa-times"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = ({ auth }) => {
    return {
        auth,
    }
}

export default connect(mapStateToProps, null)(OrderDetailsHeader);
